import React, { useEffect } from "react";
import { isIOS } from "react-device-detect";
import {
  addRealtimeHotspotAnalytics,
  updateUserLocation,
} from "../firebase/firebase";
import "./scorecard.css";
function ScoreCard({ scores, yScores, backToLobby, context }) {
  useEffect(() => {
    updateUserLocation(context, "Leaderboard");
    addRealtimeHotspotAnalytics(context, "Leaderboard");
  }, []);
  return (
    <div className={`score-card ${isIOS ? "ios-score" : ""}`}>
      <div className="heading">
        <div className="y-score">
          <div>
            <img src="/assets/images/login/user-img.png" alt="" />
            <h2>
              Your <br /> Points
            </h2>
            <h1>{yScores}</h1>
          </div>
        </div>
        <div className="s-logo">
          <img src="/assets/images/login/game-logo.png" alt="" />
        </div>
        <div className="close-i">
          <img
            src="/assets/images/login/close.png"
            alt=""
            onClick={backToLobby}
          />
        </div>
      </div>

      <div className="leader-text">
        <h2>Leaderboard</h2>
      </div>

      <div className="score-table">
        <div>
          <div className="rank">
            <div>
              <p>Rank</p>
            </div>
            {scores.map((item, pos) => (
              <div key={pos}>
                <p>{pos + 1}</p>
              </div>
            ))}
          </div>
          <div className="name">
            <div>
              <p>Name</p>
            </div>
            {scores.map((item, pos) => (
              <div key={pos}>
                <p>{item.name}</p>
              </div>
            ))}
          </div>
          <div className="score">
            <div>
              <p>Score</p>
            </div>
            {scores.map((item, pos) => (
              <div key={pos}>
                <p>{item.score}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScoreCard;
